import { render, staticRenderFns } from "./replace-mobile-dialog.vue?vue&type=template&id=521f7710&"
import script from "./replace-mobile-dialog.vue?vue&type=script&lang=js&"
export * from "./replace-mobile-dialog.vue?vue&type=script&lang=js&"
import style0 from "./replace-mobile-dialog.vue?vue&type=style&index=0&id=521f7710&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports